module.exports = __webpack_public_path__ + "static/media/11.10bc6703.png";